import status from "../../data/status.json";
import React from "react";
import {Image} from "../Image/Image";
import {getCountryName, getLink} from "./PropertyHelper";

function PropertyCard({property}) {
    const link = getLink(property);

    const rooms = property.importantSpecifications.find((spec) => spec.name === "number_of_rooms")?.value;
    const bathrooms = property.importantSpecifications.find((spec) => spec.name === "number_of_bathrooms")?.value;

    let area = property.importantSpecifications.find((spec) => spec.name === "area_bwf")?.value;
    const brute = typeof area === "number";

    area = !area ? property.specifications.find((spec) => spec.name === "area_nwf")?.value : area;

    const promotion = "promotion" in property && property.promotion === true;

    return (
        <article className="flex justify-center group cursor-pointer text-primary"
                 onClick={() => window.location.href = link}>
            <div className="relative w-full">
                <div className="z-20 text-xs p-2 top-0 right-0 absolute bg-neutral-700 text-white">
                    <p className="uppercase">{property.type === "buy" ? "à vendre" : "à louer"} |
                        réf. <strong>{property.ref}</strong></p>
                </div>
                {property.status !== "active" ? (
                        <div
                            className="absolute uppercase bg-red-500 bg-opacity-70 w-full py-1 bottom-[40%] md:bottom-1/3 text-center text-white font-bold z-20">
                            {status[property.status]}
                        </div>
                    )
                    : ""}
                <div className="bg-white w-full h-[30rem] flex flex-col">
                    <div className="z-10 h-3/5 md:h-2/3">
                            <div className="h-full w-full overflow-hidden">
                                <Image size="lg"
                                       className="h-full w-full object-cover group-hover:scale-110 transition-transform"
                                       src={property?.attachments ? property?.attachments[0]?.url : ""}
                                       alt={!promotion ? property.title.replace(/ de [0-9](,[0-9])+ pièces/gm, "") : property.name}
                                />
                            </div>
                    </div>
                    <div className="flex flex-col justify-between pt-2 h-2/5 md:h-1/3">
                        <div className="flex justify-between flex-col md:flex-row gap-2">
                            <a href={link} className="font-bold place-self-start text-xl line-clamp-2">
                                {!promotion ? property.title.replace(/ de [0-9](,[0-9])+ pièces/gm, "") : property.name}
                            </a>
                            <p className="min-w-fit text-md md:text-lg">{property.price === 0 ?
                                "Prix sur demande"
                                :
                                <>
                                    CHF {property.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")}.–{property.type === "rent" ? "/mois" : ""}
                                </>
                            }</p>
                        </div>
                        <div>
                            <div className="flex flex-col gap-2">
                                <p>{property.postalCode} {property.locality}, {property.region}, {property.country === "CH" ? "Suisse" : getCountryName(property.country)}</p>
                                <div className="flex gap-x-2 divide-x-[1px] divide-primary">
                                    {rooms ? <p>{rooms} pièce{rooms > 1 ? "s" : ""}</p> : ""}
                                    {bathrooms ? <p className={rooms ? "pl-2" : ""}>{bathrooms} salle{bathrooms > 1 ? "s" : ""} de bain</p> : ""}
                                    {area ? <p className={rooms || bathrooms ? "pl-2" : ""}>{area} m² {brute ? "bruts" : "habitables"}</p> : ""}
                                </div>
                                <p className="font-bold underline hover:text-primary-light w-fit">Plus de détails</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    );
}

export default PropertyCard;
